import EmployerWorkflowStatus from './EmployerWorkflowStatus';

export const EVENTS = {
    CLICK_ON_CANDIDATE_NAME_FEEDBACK_STEP: 'CLICK_ON_CANDIDATE_NAME_FEEDBACK_STEP',
    CLICK_ON_CANDIDATE_NAME_INTERVIEWED_STEP: 'CLICK_ON_CANDIDATE_NAME_INTERVIEWED_STEP',
    CLICK_ON_CANDIDATE_NAME_INTERESTED_STEP: 'CLICK_ON_CANDIDATE_NAME_INTERESTED_STEP',
    CLICK_ON_CANDIDATE_NAME_CONTACTED_STEP: 'CLICK_ON_CANDIDATE_NAME_CONTACTED_STEP',
    CLICK_ON_CANDIDATE_NAME_QUALIFIED_STEP: 'CLICK_ON_CANDIDATE_NAME_QUALIFIED_STEP',
    CLICK_ON_CANDIDATE_NAME_HIRED_STEP: 'CLICK_ON_CANDIDATE_NAME_HIRED_STEP',
    CLICK_ON_INTERVIEWED_TAB: 'CLICK_ON_INTERVIEWED_TAB',
    CLICK_ON_INTERESTED_TAB: 'CLICK_ON_INTERESTED_TAB',
    CLICK_ON_CONTACTED_TAB: 'CLICK_ON_CONTACTED_TAB',
    CLICK_ON_QUALIFIED_TAB: 'CLICK_ON_QUALIFIED_TAB',
    CLICK_ON_REVIEW_TAB: 'CLICK_ON_REVIEW_TAB',
    CLICK_ON_HIRED_TAB: 'CLICK_ON_HIRED_TAB',
    CLICK_ON_NEXT_BUTTON_IN_REVIEW_TAB: 'CLICK_ON_NEXT_BUTTON_IN_REVIEW_TAB',
    CLICK_ON_NEXT_BUTTON_IN_INTERVIEWED_TAB: 'CLICK_ON_NEXT_BUTTON_IN_INTERVIEWED_TAB',
    CLICK_ON_NEXT_BUTTON_IN_QUALIFIED_TAB: 'CLICK_ON_NEXT_BUTTON_IN_QUALIFIED_TAB',
    CLICK_ON_NEXT_BUTTON_IN_CONTACTED_TAB: 'CLICK_ON_NEXT_BUTTON_IN_CONTACTED_TAB',
    CLICK_ON_NEXT_BUTTON_IN_INTERESTED_TAB: 'CLICK_ON_NEXT_BUTTON_IN_INTERESTED_TAB',
    CLICK_ON_NEXT_BUTTON_IN_HIRED_TAB: 'CLICK_ON_NEXT_BUTTON_IN_HIRED_TAB',
    CLICK_ON_PREV_BUTTON_IN_REVIEW_TAB: 'CLICK_ON_PREV_BUTTON_IN_REVIEW_TAB',
    CLICK_ON_PREV_BUTTON_IN_INTERVIEWED_TAB: 'CLICK_ON_PREV_BUTTON_IN_INTERVIEWED_TAB',
    CLICK_ON_PREV_BUTTON_IN_QUALIFIED_TAB: 'CLICK_ON_PREV_BUTTON_IN_QUALIFIED_TAB',
    CLICK_ON_PREV_BUTTON_IN_CONTACTED_TAB: 'CLICK_ON_PREV_BUTTON_IN_CONTACTED_TAB',
    CLICK_ON_PREV_BUTTON_IN_INTERESTED_TAB: 'CLICK_ON_PREV_BUTTON_IN_INTERESTED_TAB',
    CLICK_ON_PREV_BUTTON_IN_HIRED_TAB: 'CLICK_ON_PREV_BUTTON_IN_HIRED_TAB',
    CLICK_ON_CANDIDATE_CONTACT_INFO_INTERESTED_TAB: 'CLICK_ON_CANDIDATE_CONTACT_INFO_INTERESTED_TAB',
    CLICK_ON_CONTINUE_ON_WEBSITE_ON_POSITION_APPROVAL_PAGE: 'CLICK_ON_CONTINUE_ON_WEBSITE_ON_POSITION_APPROVAL_PAGE',
};

export const EVENTS_QUEUE = {
    EVENTS_QUEUE_NAME: 'tracking_events_queue',
    EVENTS_QUEUE_LENGTH: 4,
};

export const EVENT_TRACKER_CANDIDATES = {
    [EmployerWorkflowStatus.FEEDBACK]: EVENTS.CLICK_ON_CANDIDATE_NAME_FEEDBACK_STEP,
    [EmployerWorkflowStatus.REVIEWED]: EVENTS.CLICK_ON_CANDIDATE_NAME_INTERESTED_STEP,
    [EmployerWorkflowStatus.CONTACTED]: EVENTS.CLICK_ON_CANDIDATE_NAME_CONTACTED_STEP,
    [EmployerWorkflowStatus.CONTACT]: EVENTS.CLICK_ON_CANDIDATE_NAME_QUALIFIED_STEP,
    [EmployerWorkflowStatus.INTERVIEW_AND_ASSESSMENT]: EVENTS.CLICK_ON_CANDIDATE_NAME_INTERVIEWED_STEP,
    [EmployerWorkflowStatus.INTERVIEW_AND_ASSESSMENT]: EVENTS.CLICK_ON_CANDIDATE_NAME_HIRED_STEP,
};

export const EVENT_TRACKER_TAB_MENU = {
    [EmployerWorkflowStatus.INTERVIEW_AND_ASSESSMENT]: EVENTS.CLICK_ON_INTERVIEWED_TAB,
    [EmployerWorkflowStatus.FEEDBACK]: EVENTS.CLICK_ON_REVIEW_TAB,
    [EmployerWorkflowStatus.CONTACT]: EVENTS.CLICK_ON_QUALIFIED_TAB,
    [EmployerWorkflowStatus.CONTACTED]: EVENTS.CLICK_ON_CONTACTED_TAB,
    [EmployerWorkflowStatus.REVIEWED]: EVENTS.CLICK_ON_INTERESTED_TAB,
    [EmployerWorkflowStatus.HIRED]: EVENTS.CLICK_ON_HIRED_TAB,
};

export const EVENT_TRACKER_MOVING_NEXT_CANDIDATE = {
    [EmployerWorkflowStatus.FEEDBACK]: EVENTS.CLICK_ON_NEXT_BUTTON_IN_REVIEW_TAB,
    [EmployerWorkflowStatus.INTERVIEW_AND_ASSESSMENT]: EVENTS.CLICK_ON_NEXT_BUTTON_IN_INTERVIEWED_TAB,
    [EmployerWorkflowStatus.CONTACT]: EVENTS.CLICK_ON_NEXT_BUTTON_IN_QUALIFIED_TAB,
    [EmployerWorkflowStatus.CONTACTED]: EVENTS.CLICK_ON_NEXT_BUTTON_IN_CONTACTED_TAB,
    [EmployerWorkflowStatus.REVIEWED]: EVENTS.CLICK_ON_NEXT_BUTTON_IN_INTERESTED_TAB,
    [EmployerWorkflowStatus.HIRED]: EVENTS.CLICK_ON_NEXT_BUTTON_IN_HIRED_TAB,
};

export const EVENT_TRACKER_MOVING_PREV_CANDIDATE = {
    [EmployerWorkflowStatus.FEEDBACK]: EVENTS.CLICK_ON_PREV_BUTTON_IN_REVIEW_TAB,
    [EmployerWorkflowStatus.INTERVIEW_AND_ASSESSMENT]: EVENTS.CLICK_ON_PREV_BUTTON_IN_INTERVIEWED_TAB,
    [EmployerWorkflowStatus.CONTACT]: EVENTS.CLICK_ON_PREV_BUTTON_IN_QUALIFIED_TAB,
    [EmployerWorkflowStatus.CONTACTED]: EVENTS.CLICK_ON_PREV_BUTTON_IN_CONTACTED_TAB,
    [EmployerWorkflowStatus.REVIEWED]: EVENTS.CLICK_ON_PREV_BUTTON_IN_INTERESTED_TAB,
    [EmployerWorkflowStatus.HIRED]: EVENTS.CLICK_ON_PREV_BUTTON_IN_HIRED_TAB,
};

export const EVENT_TRACKER_CANDIDATE_CONTACT_INFO = {
    [EmployerWorkflowStatus.REVIEWED]: EVENTS.CLICK_ON_CANDIDATE_CONTACT_INFO_INTERESTED_TAB,
};

export const EVENTS_TO_TRACK_IMMEDIATELY = [
    EVENTS.CLICK_ON_CANDIDATE_NAME_INTERESTED_STEP,
    EVENTS.CLICK_ON_NEXT_BUTTON_IN_INTERESTED_TAB,
    EVENTS.CLICK_ON_PREV_BUTTON_IN_INTERESTED_TAB,
    EVENTS.CLICK_ON_CANDIDATE_CONTACT_INFO_INTERESTED_TAB,
    EVENTS.CLICK_ON_CONTINUE_ON_WEBSITE_ON_POSITION_APPROVAL_PAGE,
];
